import { AutoCompleteSuggestion } from 'models/AutoCompleteSuggestion';
import { hasElements } from 'utils';

export const hasSearchResult = ({
  suggestedPhrases,
  suggestedProducts,
  suggestedCategories,
  suggestedBrandCategories,
  suggestedDidYouMean
}: AutoCompleteSuggestion) => {
  return hasElements([
    ...suggestedPhrases,
    ...suggestedProducts,
    ...suggestedCategories,
    ...suggestedBrandCategories,
    ...suggestedDidYouMean
  ]);
};
